<template>
    <div class="heading-analytics-correctness">
        <h2 class="heading-analytics-correctness__heading">
            {{ headingText }}
            <span class="heading-analytics-correctness__highlighted-text">{{ highlightedText }}</span>
        </h2>
        <p class="heading-analytics-correctness__desc">{{ descText }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            headingText: {
                type: String,
                default: 'Lorem Ipsum: ',
            },
            highlightedText: {
                type: String,
                default: 'Dolor',
            },
            descText: {
                type: String,
                default: 'Lorem ipsum dolor sit amet consectetur elit nulla.',
            },
        }
    };
</script>
<style scoped src="@/css/components/heading-analytics-correctness.css"></style>